import Base from '../../ts/_base';
import Slider from '../../components/multi-level-slide-menu/ts/_multi-level-slider';
import SliderScreen from '../../components/multi-level-slide-menu/ts/_slide-screen';


export default class ProfilePages extends Base {
    private slider: Slider;

    get childSelectors() {
        return {
            ...this.selectors,
            profileMenu: '.profile-menu__account ul',
            profileActiveItem: '.profile-menu__account ul .active'
        }
    }

    get childClassList() {
        return {
            ...this.classList,
            activeLink: 'active'
        }
    }

    initialize(): void {
        this.slider = new Slider('profile-pages-slider');
        this.slider.registerScreen(this.buildScreen());
        this.slider.build();
    }

    buildScreen(): SliderScreen {
        const titleElm = (this.queryElm(this.childSelectors.profileActiveItem) as HTMLElement);
        const title =  titleElm ? titleElm.innerHTML : 'Profile Pages';
        const menuHTML = (this.queryElm(this.childSelectors.profileMenu) as HTMLElement).innerHTML;
        const screen = new SliderScreen(title, () => `<ul class="list-unstyled px-4">${menuHTML}</ul>`);
        return screen;
    }
}